module.exports = __webpack_public_path__ + "img/CY.634de7f0.svg";